<template>
  <Dialog
    width="536px"
    background="#383f48"
    titleAlign="center"
    :title="$$t('create.download_wave_mp3_title')"
    customClass="download-mine-audio-dialog"
    :hideCloseBtn="true"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <div class="height-all download-mine-audio flex-column">
      <div class="download-mine-audio-subtitle tc">
        {{ $$t("create.download_wave_mp3_subtitle") }}
      </div>
      <div class="download-mine-audio-credits tc">
        {{ $$t("create.credits_remaining") }} {{ renderData.userCredits }}
      </div>
      <div class="download-mine-audio-done-btn-box">
        <div class="download-mine-audio-done-btn-item-box flex1 width-0 tr">
          <div class="download-mine-audio-done-btn fn-inline">
            <Button
              @click="closeDialog"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '50px',
                '--background': 'rgba(255, 255, 255, 0.1)',
                '--fontColor': '#fff',
                '--fontSize': '16px',
                '--fontWeight': 'bold',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                '--fontColorHover': '#fff',
              }"
            >
              {{ $$t("create.cancel") }}
            </Button>
          </div>
        </div>
        <div class="download-mine-audio-done-btn-item-margin"></div>
        <div class="download-mine-audio-done-btn-item-box flex1 width-0 tl">
          <div class="download-mine-audio-done-btn fn-inline">
            <Button
              @click="onDoneClick"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '50px',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--background':
                  'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
                '--backgroundHover':
                  'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
                '--fontColorHover': '#000',
              }"
            >
              {{ $$t("create.download") }}
            </Button>
          </div>
        </div>
      </div>
      <div
        class="download-mine-audio-remainder-credits tc"
        v-if="renderData.userCredits < 99"
      >
        {{ $$t("create.credits_not_enough") }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"
import { useRouter, useRoute } from "vue-router"
import Dialog from "@/components/basic/dialog/Dialog.vue"
import Button from "@/components/basic/button/Button.vue"
import feedListApi from "@/api/api/feedListApi.js"

import useUserDataStore from "@/store/userDataStore.js"
const userDataStore = useUserDataStore()

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

import {
  StyleLabelData,
  EmotionalLabelData,
  getEnOptions,
  getSelectValue,
} from "@/config/const.js"
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))
  .appContext?.config?.globalProperties?.$router
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  visible: {
    type: Boolean,
    default: false,
  },
})
const emits = defineEmits(["update:visible", "download"])

const renderData = reactive({
  visible: props.visible,
  userCredits: userDataStore.credits,
})

const onClose = () => {
  renderData.visible = false
  emits("update:visible", false)
  emits("cancel")
}

const onDoneClick = async () => {
  if (renderData.userCredits < 99) {
    onClose()
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "create",
        membership_source2: "download",
      },
    })
  } else {
    emits("download")
  }
}

const closeDialog = () => {
  renderData.visible = false
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)
const getUserInfo = () => {
  feedListApi
    .feedCardGetUsertInfo({
      song_id: props.item.song_id,
    })
    .then((res) => {
      if (res.code == 200) {
        userDataStore.setCredits(res.data.wallet.gold)
        renderData.userCredits = res.data.wallet.gold
      }
    })
}
onMounted(() => {
  getUserInfo()
})
</script>
<style lang="scss">
.custom-dialog.download-mine-audio-dialog {
  .dialog-box {
    padding: 40px 0;
  }
}
.download-mine-audio {
  margin: 40px 50px 0px 50px;
  .download-mine-audio-subtitle {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    color: #ffffff;
  }
  .download-mine-audio-credits {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    color: #ffffff;
    margin: 32px 0;
  }
  .download-mine-audio-remainder-credits {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    color: #ff5745;
    margin: 32px 0 0 0;
  }
  .download-mine-audio-done-btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .download-mine-audio-done-btn-item-margin {
      width: 20px;
    }
    .download-mine-audio-done-btn {
      width: 160px;
      max-width: 100%;
    }
  }
}
</style>
